import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";
import {
  getSaleInvoice,
  getSaleInvoiceById,
  getParticularPage,
  getSaleInvoiceDeliveryDetail,
  getNext,
  getPrevious,
  handleSearch,
  createSaleInvoice,
  getSaleInvoiceAdditionalChargeList,
} from "./thunk";
import { NepaliDate } from "@zener/nepali-datepicker-react";
import { dateFormater } from "../../../../../../Utils/dateFormater";

const initialState = {
  saleInvoices: [],
  edit: false,
  saleInvoice: null,
  count: 0,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingCreate: false,
  loadingUpdated: false,
  loadingSaleInvoice: false,
  loadingNext: false,
  loadingDetails: false,
  saleInvoiceDetails: [
    {
      unique: uuidv4(),
      product: null,
      availableStock: 0,
      discription: "",
      quantity: 0,
      unit: null,
      altQuantity: 0,
      actualQuantity: 0,
      rate: 0,
      amount: 0,
      requiredDate: dateFormater(new NepaliDate()),
    },
  ],
  additionalCharges: [],
  saveAndContinue: false,
  showCreateModal: false,
  selectedSaleInvoice: null,
  selectedSaleInvoiceDetails: [],
  selectedAdditionalCharges: [],
};

export const saleInvoiceSlice = createSlice({
  name: "saleInvoice",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    setSaveAndContinue: (state, { payload }) => {
      state.saveAndContinue = payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },

    setMainOrder: (state, action) => {
      state.selectedSaleInvoice = action.payload;
    },
    setOrderDetails: (state, action) => {
      state.selectedSaleInvoiceDetails = action.payload.map((value) => ({
        ...value,
        description: value.product?.name || "",
      }));
    },
    setAdditionalDetails: (state, action) => {
      state.selectedAdditionalCharges = action.payload.map((value) => {
        return { ...value, unique: uuidv4() };
      });
    },

    updateSaleInvoiceAddCharges: (state, action) => {
      state.additionalCharges = action.payload;
    },
    setSaleInvoice: (state, action) => {
      state.saleInvoice = action.payload;
    },
    setAdditionalCharges: (state, action) => {
      state.additionalCharges = action.payload;
    },

    setSaleInvoiceDetailsUpdated: (state, action) => {
      state.saleInvoiceDetails = [
        ...action.payload.map((value) => ({
          ...value,
          description: value.product?.name || "",
        })),
        {
          unique: uuidv4(),
          product: null,
          availableStock: 0,
          discription: "",
          quantity: 0,
          unit: null,
          altQuantity: 0,
          actualQuantity: 0,
          rate: 0,
          amount: 0,
          requiredDate: dateFormater(new NepaliDate()),
        },
      ];
    },
    saleInvoiceDetailsUpdated: (state, action) => {
      state.saleInvoiceDetails = action.payload;
    },
    clearSelectedOrderData: (state) => {
      state.selectedSaleInvoice = null;
      state.selectedSaleInvoiceDetails = [];
      state.selectedAdditionalCharges = [];
    },
    clearSaleInvoiceDetails: (state, action) => {
      state.saleInvoiceDetails = [
        {
          unique: uuidv4(),
          product: null,
          availableStock: 0,
          discription: "",
          quantity: 0,
          unit: null,
          altQuantity: 0,
          actualQuantity: 0,
          rate: 0,
          amount: 0,
          requiredDate: dateFormater(new NepaliDate()),
        },
      ];
    },

    clearAllSaleInvoice: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingSaleInvoice = false;
      state.saleInvoice = null;
      state.selectedSaleInvoice = null;
      state.selectedSaleInvoiceDetails = [];
      state.selectedAdditionalCharges = [];
      state.saleInvoiceDetails = [
        {
          unique: uuidv4(),
          product: null,
          availableStock: 0,
          discription: "",
          quantity: 0,
          unit: null,
          altQuantity: 0,
          actualQuantity: 0,
          rate: 0,
          amount: 0,
          requiredDate: dateFormater(new NepaliDate()),
        },
      ];
      state.additionalCharges = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSaleInvoiceAdditionalChargeList.pending, (state) => {
      state.additionalCharges = null;
    });
    builder.addCase(getSaleInvoiceAdditionalChargeList.fulfilled, (state, action) => {
      state.additionalCharges = action.payload.data;
    });
    builder.addCase(getSaleInvoiceAdditionalChargeList.rejected, (state) => {
      state.additionalCharges = null;
    });
    // get
    builder.addCase(createSaleInvoice.pending, (state) => {
      state.loadingCreate = true;
    });
    builder.addCase(createSaleInvoice.fulfilled, (state, action) => {
      state.loadingCreate = false;
    });
    builder.addCase(createSaleInvoice.rejected, (state) => {
      state.loadingCreate = false;
    });
    builder.addCase(getSaleInvoiceDeliveryDetail.pending, (state) => {
      state.loadingDetails = true;
      // state.saleInvoiceDetails = null;
      // state.deliveryNoteMainAdditionalChargeCost = [];
    });
    builder.addCase(getSaleInvoiceDeliveryDetail.fulfilled, (state, action) => {
      state.loadingDetails = false;
      // state.saleInvoice = action.payload.data;
      // state.saleInvoiceDetails = action.payload.data.deliveryNotesDetails;
      // state.additionalCharges = action.payload.data.deliveryNoteMainAdditionalChargeCost;
    });
    builder.addCase(getSaleInvoiceDeliveryDetail.rejected, (state) => {
      state.loadingDetails = false;
      // state.saleInvoiceDetails = null;
    });
    // getSaleInvoiceById
    builder.addCase(getSaleInvoiceById.pending, (state) => {
      state.loading = true;
      state.saleInvoice = null;
    });
    builder.addCase(getSaleInvoiceById.fulfilled, (state, action) => {
      state.edit = true;
      state.loading = false;
      state.saleInvoice = action.payload.data;
      state.saleInvoiceDetails = action.payload.data?.saleInvoiceDetails.map((value) => {
        return { ...value, unique: uuidv4() };
      });
      state.additionalCharges = action.payload.data?.salesInvoiceMainAdditionalChargeCost.map((value) => {
        return { ...value, unique: uuidv4() };
      });
    });
    builder.addCase(getSaleInvoiceById.rejected, (state) => {
      state.edit = false;
      state.loading = false;
      state.saleInvoice = null;
    });
    builder.addMatcher(
      isAnyOf(
        getSaleInvoice.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingSaleInvoice = true;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getSaleInvoice.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingSaleInvoice = false;
        state.saleInvoices = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getSaleInvoice.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingSaleInvoice = false;
      }
    );
  },
});

export const {
  setShowCreateModal,
  setSaveAndContinue,
  goToPage,
  setMainOrder,
  setOrderDetails,
  setAdditionalDetails,

  setSaleInvoice,
  setAdditionalCharges,
  setSaleInvoiceDetailsUpdated,
  updateSaleInvoiceAddCharges,
  saleInvoiceDetailsUpdated,
  clearSelectedOrderData,
  clearSaleInvoiceDetails,
  clearAllSaleInvoice,
} = saleInvoiceSlice.actions;

export default saleInvoiceSlice.reducer;
